import { DEFAULT_PROFILE_IMAGE_PATH } from 'common/ProviderPreview/constants'
import styles from './index.module.scss'
import classNames from 'classnames'

type ProviderImagesComponentProps = {
  otherProvidersForPractice: ProviderMetadataForPractice[]
  numberOfImagesToDisplay?: number
  width?: number
  height?: number
  imagesWithBorder?: boolean
}

const ProviderImagesComponent: React.FC<ProviderImagesComponentProps> = ({
  otherProvidersForPractice = [],
  numberOfImagesToDisplay = 4,
  width = 40,
  height = 40,
  imagesWithBorder = false,
}) => (
  <div className={styles.provider_images_list_container}>
    {otherProvidersForPractice
      ?.slice(0, numberOfImagesToDisplay)
      ?.map((provider) => (
        <span key={provider.id} className={styles.provider_image_container}>
          <img
            key={provider.id}
            srcSet={
              provider?.profileImagePath?.length
                ? provider.profileImagePath
                : DEFAULT_PROFILE_IMAGE_PATH
            }
            alt={'Provider profile' + ' image'}
            width={width}
            height={height}
            className={classNames(styles.provider_image, {
              [styles.provider_image_withBorder]: imagesWithBorder,
            })}
          />
        </span>
      ))}
  </div>
)

export default ProviderImagesComponent
